<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";


export default {
    name: "radarEchart",
    props: {
        id:{
            type: String,
            default:"radar_echarts"
        },
        dataList:{
            type: Array,
            default: []
        }
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
        dataList(newValue,oldValue){
            this.chartList = newValue;
            this.init()
        }
    },
    data() {
        return {
            radarChart: null,
            chartList:[],
            chartOption:{
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    data: ['当前值', '基准值'],
                    bottom: '-1%',
                    left: 'center'
                },
                aria:{
                    enabled:true,
                },
                radar: {
                    // shape: 'circle',
                    indicator: [
                        {name:"课标与教材解读",max:100},
                        {name:"教学设计实施",max:100},
                        {name:"教学反思评价",max:100},
                        {name:"技术融合教学",max:100},
                        {name:"教学效果评估",max:100},
                    ]
                },
                series: [
                    {
                        color: [
                            '#54b4dc',
                            '#f0a959',
                        ],
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        },
                        type: 'radar',
                        data: [
                            {
                                value: [0,0,0,0,0],
                                name: '当前值',
                                label: {
                                    show: true,
                                    fontSize: 13,
                                    color: '#54b4dc',
                                    formatter: function (params) {
                                        return params.value;
                                    }
                                }
                            },
                            {
                                value: [0,0,0,0,0],
                                name: '基准值',
                                label: {
                                    show: true,
                                    fontSize: 12,
                                    color:"#f0a959",
                                    formatter: function (params) {
                                        return params.value;
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.chartList = this.dataList;
            const list = [];
            const listDq = [];//当前值
            const listJz = [];//基准值
            if (this.chartList&&this.chartList.length>0){
                this.chartList.forEach(item => {
                    listDq.push(item.index_value);
                    listJz.push(item.ck_index_value);
                    list.push({'name':item.name,'max':100})
                })
                this.chartOption.radar.indicator = list;
                this.chartOption.series[0].data[0].value = listDq
                this.chartOption.series[0].data[1].value = listJz
            }
            this.radarChart = echarts.init(document.getElementById(this.id));
            this.radarChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    color: #333!important;
    display: flex;
    > div {
        width: 100%;
        height: 400px;
    }
    div + div {
        margin-left: 10px;
    }
}
</style>